import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Endpoints } from '../../../core/enums/endpoints';

@Injectable({
  providedIn: 'root',
})
export class SolutionService {
  constructor(
    private httpclient: HttpClient
  ) {}

  sendForm(data: any) {
    return this.httpclient.post(`${environment.apiUrl}${Endpoints.SOLUTIONS}`, data);
  }

}
